var _tspan, _tspan2, _tspan3, _tspan4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyStateFitupWeld = function SvgEmptyStateFitupWeld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.114,
    height: 148
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.5,
    cy: 68,
    rx: 67.5,
    ry: 68,
    style: {
      fill: "#ecf5f9"
    },
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7 32.984H3.2a3.2 3.2 0 0 1-3.2-3.2V3.2A3.2 3.2 0 0 1 3.2 0h44.5a3.2 3.2 0 0 1 3.2 3.2v26.582a3.2 3.2 0 0 1-3.2 3.2",
    "data-name": "Fill 1",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(31.984 35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7 32.984H3.2a3.2 3.2 0 0 1-3.2-3.2V3.2A3.2 3.2 0 0 1 3.2 0h44.5a3.2 3.2 0 0 1 3.2 3.2v26.582a3.2 3.2 0 0 1-3.2 3.2",
    "data-name": "Fill 3",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(53.004 50.011)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7 32.984H3.2a3.2 3.2 0 0 1-3.2-3.2V3.2A3.2 3.2 0 0 1 3.2 0h44.5a3.2 3.2 0 0 1 3.2 3.2v26.582a3.2 3.2 0 0 1-3.2 3.2",
    "data-name": "Fill 5",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(23.001 70.924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7 32.984H3.2a3.2 3.2 0 0 1-3.2-3.2V3.2A3.2 3.2 0 0 1 3.2 0h44.5a3.2 3.2 0 0 1 3.2 3.2v26.582a3.2 3.2 0 0 1-3.2 3.2",
    "data-name": "Fill 7",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(61.88 91.892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.058 12h41.811v2.941H3.028v2.947H.051C.035 17.641 0 17.372 0 17.1V1.941C0 .459.464 0 1.96 0h46.879c1.637 0 2.065.42 2.065 2.02v28.826c0 1.684-.41 2.1-2.086 2.1H1.939C.458 32.942 0 32.48 0 30.984v-3.97h2.944v2.876h44.918V3.066H3.058z",
    "data-name": "Fill 9",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(61.931 91.912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9 11.932h-2.961V3.041H3.066v8.911h23.826v2.976H3.051V29.92H17.89v2.971c-.261.017-.531.048-.8.049H1.932C.456 32.941 0 32.477 0 30.976V1.964C0 .466.458 0 1.936 0h46.971c1.557 0 2 .441 2 2v9.078z",
    "data-name": "Fill 11",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(23 70.945)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.906 4.448H47.95V3.062H3.056v8.878h14.83v3.012H3.041v14.96H17.9v3c-.171.013-.319.034-.467.034H1.713C.534 32.939 0 32.411 0 31.227V1.746C0 .517.53 0 1.78 0h47.347c1.247 0 1.768.523 1.778 1.746.007.87 0 1.74 0 2.7",
    "data-name": "Fill 13",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(31.984 35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.033 2.953v7.5h26.84v3.008H3.013V17.9H.044C.03 17.589 0 17.287 0 16.984V1.73C0 .549.538 0 1.7 0h32.1c.181 0 .363.018.589.03v2.923z",
    "data-name": "Fill 15",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(52.945 49.977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.944v17.887h26.335l-1.984-1.743 2.386-2.108c.925.927 1.993 2 3.063 3.071 2.336 2.338 2.338 2.338-.028 4.7q-1.522 1.521-3.052 3.032a.6.6 0 0 1-.174.078l-2.165-2.133 1.921-1.538-.151-.309H2.029C.421 20.938 0 20.514 0 18.882V.911z",
    "data-name": "Fill 17",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(43.963 94.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32.946v-2.968h16.378V3.021h-4.37v-3c2.075 0 4.155-.069 6.227.033.844.042 1.193.772 1.189 1.635-.014 2.837 0 5.675 0 8.512v20.672c0 1.664-.414 2.07-2.108 2.07H0",
    "data-name": "Fill 19",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(84.433 49.973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17.557c1.355 0 1.856.5 1.857 1.855q.005 7.862 0 15.724v1l.192.119 1.563-1.931 2.19 2.286c-1.478 1.507-2.955 3.068-4.5 4.559a1.33 1.33 0 0 1-1.949-.045c-1.519-1.473-2.991-3-4.515-4.532l2.31-2.184 1.486 1.877.185-.145V3H0z",
    "data-name": "Fill 21",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(73.956 42.488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.266 15.131 1.967 1.558L4.755 19.1c-.509-.619-1-1.29-1.57-1.893-.853-.909-1.77-1.759-2.635-2.658a1.44 1.44 0 0 1-.11-2.167c1.472-1.519 3-2.987 4.528-4.5L7.1 10.069 5.238 11.6l.145.228h18.58V0h2.971c.017.257.049.527.049.8q.005 6.13 0 12.261c0 1.353-.495 1.838-1.868 1.839H5.41l-.144.234",
    "data-name": "Fill 23",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(52.909 74.013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.885h8.851V0H0z",
    "data-name": "Fill 25",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(50.024 100.959)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.875h2.871V0H0z",
    "data-name": "Fill 27",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(67.988 42.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.907h2.862V0H0z",
    "data-name": "Fill 28",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(76.977 67.984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.9h2.853V0H0z",
    "data-name": "Fill 29",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(44.023 88.935)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 1.5a1.463 1.463 0 0 1-1.45 1.485A1.46 1.46 0 0 1 0 1.49 1.464 1.464 0 0 1 1.542 0a1.456 1.456 0 0 1 1.442 1.5",
    "data-name": "Fill 30",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(37.976 40.993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.987 1.519A1.474 1.474 0 0 1 1.42 2.987 1.47 1.47 0 0 1 0 1.466 1.456 1.456 0 0 1 1.471 0a1.47 1.47 0 0 1 1.516 1.519",
    "data-name": "Fill 31",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(43.965 40.993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.489 2.984A1.457 1.457 0 0 1 0 1.536 1.463 1.463 0 0 1 1.5 0a1.464 1.464 0 0 1 1.484 1.541 1.464 1.464 0 0 1-1.495 1.443",
    "data-name": "Fill 32",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(49.955 40.994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.485 2.987A1.47 1.47 0 0 1 0 1.437 1.457 1.457 0 0 1 1.5 0a1.47 1.47 0 0 1 1.487 1.547 1.47 1.47 0 0 1-1.5 1.44",
    "data-name": "Fill 33",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(58.938 55.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 1.459a1.466 1.466 0 0 1-1.413 1.525A1.465 1.465 0 0 1 0 1.526 1.46 1.46 0 0 1 1.506 0a1.46 1.46 0 0 1 1.478 1.459",
    "data-name": "Fill 34",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(64.928 55.971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 1.49a1.465 1.465 0 0 1-1.537 1.495A1.46 1.46 0 0 1 0 1.495 1.463 1.463 0 0 1 1.536 0a1.46 1.46 0 0 1 1.448 1.49",
    "data-name": "Fill 35",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(70.918 55.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 1.519a1.464 1.464 0 0 1-1.472 1.467A1.46 1.46 0 0 1 0 1.468 1.466 1.466 0 0 1 1.565 0a1.46 1.46 0 0 1 1.42 1.517",
    "data-name": "Fill 36",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(28.991 76.937)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 1.49a1.465 1.465 0 0 1-1.537 1.495A1.46 1.46 0 0 1 0 1.495 1.463 1.463 0 0 1 1.536 0a1.46 1.46 0 0 1 1.448 1.49",
    "data-name": "Fill 37",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(34.981 76.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.451 0a1.47 1.47 0 0 1 1.535 1.5 1.46 1.46 0 0 1-1.45 1.488A1.47 1.47 0 0 1 0 1.49 1.47 1.47 0 0 1 1.451 0",
    "data-name": "Fill 38",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(40.969 76.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.447 2.985A1.46 1.46 0 0 1 0 1.495 1.463 1.463 0 0 1 1.537 0a1.465 1.465 0 0 1 1.446 1.583 1.466 1.466 0 0 1-1.536 1.4",
    "data-name": "Fill 39",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(67.923 97.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 1.5a1.466 1.466 0 0 1-1.542 1.49A1.457 1.457 0 0 1 0 1.49 1.464 1.464 0 0 1 1.541 0a1.46 1.46 0 0 1 1.443 1.5",
    "data-name": "Fill 40",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(73.913 97.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.987 1.493a1.46 1.46 0 0 1-1.443 1.495A1.47 1.47 0 0 1 0 1.5 1.47 1.47 0 0 1 1.445 0a1.47 1.47 0 0 1 1.542 1.493",
    "data-name": "Fill 41",
    style: {
      fill: "#aecee0"
    },
    transform: "translate(79.9 97.903)"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "+",
    style: {
      fontFamily: "Graphik-Regular,Graphik",
      letterSpacing: ".02em",
      fontSize: 14,
      fill: "#aecee0"
    },
    transform: "translate(100.114 29)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 3.367,
    y: 11
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "+ copy 2",
    style: {
      fontSize: 12,
      fontFamily: "Graphik-Regular,Graphik",
      letterSpacing: ".02em",
      fill: "#ecf5f9"
    },
    transform: "translate(108.114 14)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 3.886,
    y: 10
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "+ copy 3",
    style: {
      fontSize: 12,
      fontFamily: "Graphik-Regular,Graphik",
      letterSpacing: ".02em",
      fill: "#ecf5f9"
    },
    transform: "translate(121.114 22)"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 3.886,
    y: 10
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "+ copy 4",
    style: {
      fontFamily: "Graphik-Regular,Graphik",
      letterSpacing: ".02em",
      fontSize: 14,
      fill: "#aecee0"
    },
    transform: "translate(121.114)"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 3.367,
    y: 11
  }, "+"))));
};
export { SvgEmptyStateFitupWeld as ReactComponent };
export default "data:image/svg+xml;base64,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";